export default __webpack_public_path__ + "static/media/Img401.04c4f176.jpg";